import { LogicTypes } from 'modules/shared/DataGrid';

export const defaultGridState = {
  sort: [],
  filter: {
    logic: LogicTypes.and,
    filters: [],
  },
  pagination: { skip: 0, pageSize: 15 },
};
